module.exports = __webpack_public_path__ + "img/2-5.3a3d208d.svg";